import { innerSearch } from 'api/Api';
import PayverseDirectHeader from 'app/components/PayverseDirectHeader';
import QRCode from 'qrcode.react';
import React, { useEffect, useState } from 'react';
import { isMobile } from 'react-device-detect';
import { useTranslation } from 'react-i18next';
import { useMutation } from 'react-query';
import { useLocation, useNavigate } from 'react-router-dom';

const DebiaProcess = () => {
  const navigate = useNavigate();
  const { t, i18n } = useTranslation();

  const searchParams = useLocation().search;
  const paramPayUrl = new URLSearchParams(searchParams).get('payUrl');
  const paramTid = new URLSearchParams(searchParams).get('tid');
  const [apiRequestInterval, setApiRequestInterval] = useState(true);

  const initialTime = 120;
  const [timeLeft, setTimeLeft] = useState(initialTime);

  const formatTime = (seconds: number) => {
    const minutes = Math.floor(seconds / 60);
    const remainingSeconds = seconds % 60;
    return `${minutes.toString().padStart(2, '0')}:${remainingSeconds
      .toString()
      .padStart(2, '0')}`;
  };

  const transactPolling = useMutation(() => innerSearch(paramTid), {
    onSuccess: data => {
      const returnUrl = data.data.returnUrl;
      const response = data.data.response;

      //Status 예외처리
      if (
        response.resultStatus === null ||
        response.resultStatus === undefined
      ) {
        navigate('/error');
        return;
      }
      if (response.resultStatus === 'SUCCESS') {
        createFormAndSubmit(response, returnUrl);
      }
    },
    onError: error => {
      navigate('/error');
    },
  });

  const createFormAndSubmit = (formData, returnUrl) => {
    const form = document.createElement('form');
    form.setAttribute('method', 'POST');
    form.setAttribute('action', `${returnUrl}`);
    form.style.display = 'none';
    Object.entries(formData).forEach(([key, value]) => {
      const input = document.createElement('input');
      input.setAttribute('type', 'hidden');
      input.setAttribute('name', key);
      input.setAttribute('value', String(value));
      form.appendChild(input);
    });
    document.body.appendChild(form);
    form.submit();
  };

  useEffect(() => {
    if (timeLeft > 0) {
      const timerId = setInterval(() => {
        setTimeLeft(prevTime => prevTime - 1);
      }, 1000);

      return () => clearInterval(timerId);
    }
  }, [timeLeft]);

  useEffect(() => {
    const interval = setTimeout(() => {
      transactPolling.mutate();
      setApiRequestInterval(false);
    }, 5000);

    return () => {
      if (!apiRequestInterval) {
        clearTimeout(interval);
      }
    };
  }, [apiRequestInterval]);

  useEffect(() => {
    // 5초마다 API 요청을 보냄
    if (timeLeft <= 105 && timeLeft > 0) {
      setApiRequestInterval(true);
    } else if (timeLeft === 0) {
      if (!isMobile) {
        navigate(`/pc/debia/result?tid=${paramTid}`);
      } else {
        navigate(`/mo/debia/result?tid=${paramTid}`);
      }
      setApiRequestInterval(false);
    } else {
      setApiRequestInterval(false);
    }
  }, [timeLeft, apiRequestInterval]);

  return (
    <div className="payverse-wrap">
      <div className="payverse">
        <PayverseDirectHeader />
        <div style={{ height: 'calc(100% - 90px' }}>
          <div
            style={{
              flexDirection: 'column',
              height: '100%',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
            }}
          >
            <>
              {paramPayUrl && (
                <div
                  style={{
                    border: '2px solid #0f0041',
                    padding: '10px 10px',
                    borderRadius: 10,
                  }}
                >
                  <QRCode
                    value={decodeURIComponent(paramPayUrl)}
                    style={{ width: '180px', height: '180px' }}
                  />
                </div>
              )}
              <div
                style={{
                  color: timeLeft <= 30 ? 'red' : 'gray',
                  marginTop: 20,
                }}
              >
                {t('scan_qr_code')} {formatTime(timeLeft)}
              </div>
            </>
          </div>
        </div>
      </div>
    </div>
  );
};

export default DebiaProcess;
